module.exports = __webpack_public_path__ + "img/struktur.23833777.png";